export const titles = [
    { value: 'herr', label: 'Herr' },
    { value: 'frau', label: 'Frau' }
];
